'use strict';

var app = angular.module('saturn.form.select', [
  'saturn.filter',
  'saturn.utils'
]);

var SelectDirective = require('./SelectDirective');
var SelectRegistry = require('./SelectRegistry');
var SelectService = require('./SelectService');

// ## Services

app.service('SelectService', [
  '$document',
  '$rootScope',
  SelectService
]);

app.directive('sbSelect', [
  '$compile',
  '$document',
  '$parse',
  '$templateCache',
  'SelectService',
  SelectDirective
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/form/src/select/index.js